import { render, staticRenderFns } from "./ThanksLetters.vue?vue&type=template&id=205f4c88"
import script from "./ThanksLetters.vue?vue&type=script&lang=js"
export * from "./ThanksLetters.vue?vue&type=script&lang=js"
import style0 from "./ThanksLetters.vue?vue&type=style&index=0&id=205f4c88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports